module.exports = __webpack_public_path__ + "static/media/fabian@2x.c5c8358a.png";